import React, { createContext, memo, useState } from "react";
import RequestHelper from "../apis/RequestHelper";
import { IKeyword } from "../types/language/keyword.d";
import { ILanguage } from "../types/language/language.d";
import { IDictionaryGroup } from "../types/dictionary.d";

interface IAppContext {
  returnUrl: string | null;
  setReturnUrl: (returnUrl: string | null) => void;
  languages?: ILanguage[];
  keywords?: IKeyword[];
  dictionaries?: IDictionaryGroup[];
  selectedLanguage?: Partial<ILanguage>;
  loadConfig: () => void;
  setLanguage: (language: ILanguage) => void;
}

const initialState: IAppContext = {
  returnUrl: null,
  setReturnUrl: (returnUrl: string | null) => { },
  languages: [],
  keywords: [],
  dictionaries: [],
  selectedLanguage: {},
  loadConfig: () => { },
  setLanguage: (language: ILanguage) => { }
};

const AppContext = createContext<IAppContext>(initialState);

export const AppProvider = memo((props: any) => {
  const [state, setState] = useState<IAppContext>({
    ...initialState,
    setReturnUrl: (returnUrl: string | null) => {
      setState((state) => ({
        ...state,
        returnUrl,
      }));
    },
    loadConfig: async () => {
      const url = "/configs?projectKey=cas";
      const res = await RequestHelper.noAuthKari.get(url);
      const { keywords, languages, dictionary: dictionaries } = res.data.data;
      setState((state) => ({
        ...state,
        keywords,
        languages,
        dictionaries,
      }));
    },
    setLanguage: (language: ILanguage) => {
      setState((state) => ({
        ...state,
        selectedLanguage: language,
      }));
    }
  });

  return (
    <AppContext.Provider value={state}>{props.children}</AppContext.Provider>
  );
});

export default AppContext;
